export enum SituacaoLaudoEnum {
    NAO_AVALIADO = "Não Avaliado",
    ACEITO = "Aceito",
    RECUSADO = "Recusado"
}